import {RouteConfig} from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";
import Originators from "@/pages/Pages/Settings/Originators.vue";
import Originator from "@/pages/Pages/Settings/Originator.vue";
import SystemSettings from "@/pages/Pages/Settings/SystemSettings.vue";
import SystemSetting from "@/pages/Pages/Settings/SystemSetting.vue";
import MessageTypes from "@/pages/Pages/Settings/MessageTypes.vue";
import MessageType from "@/pages/Pages/Settings/MessageType.vue";
import MessageCategories from "@/pages/Pages/Settings/MessageCategories.vue";
import MessageCategory from "@/pages/Pages/Settings/MessageCategory.vue";
import Regexes from "@/pages/Pages/Settings/Regexes.vue";
import Reports from "@/pages/Pages/Settings/Reports.vue";
import Duplicates from "@/pages/Pages/Settings/Duplicates.vue";
import Duplicate from "@/pages/Pages/Settings/Duplicate.vue";
import QuantityLimits from "@/pages/Pages/Settings/QuantityLimits.vue";
import QuantityLimit from "@/pages/Pages/Settings/QuantityLimit.vue";
import ProviderConnections from "@/pages/Pages/Settings/ProviderConnections.vue";
import Partners from "@/pages/Pages/Settings/Partners.vue";
import Partner from "@/pages/Pages/Settings/Partner.vue";
import PreprocessingRules from "@/pages/Pages/Settings/PreprocessingRules.vue";
import PreprocessingRuleItem from "@/pages/Pages/Settings/PreprocessingRule.vue";
import Accounts from "@/pages/Pages/Settings/Accounts.vue";
import Account from '@/pages/Pages/Settings/Account.vue';
import SmppConnections from "@/pages/Pages/Settings/SmppConnections.vue";
import SmppConnection from "@/pages/Pages/Settings/SmppConnection.vue";
import ServiceProviders from "@/pages/Pages/Settings/ServiceProviders.vue";
import ServiceProvider from "@/pages/Pages/Settings/ServiceProvider.vue";
import PartnersConnections from "@/pages/Pages/Settings/PartnersConnections.vue";
import BlackLists from "@/pages/Pages/Settings/BlackLists.vue";
import BlackList from "@/pages/Pages/Settings/BlackList.vue";
import BlackListContacts from "@/pages/Pages/Settings/BlackListContacts.vue";
import BlackListContact from "@/pages/Pages/Settings/BlackListContact.vue";
import BlackListGenerals from "@/pages/Pages/Settings/BlackListGenerals.vue";
import BlackListGeneral from "@/pages/Pages/Settings/BlackListGeneral.vue";

import TemplateParams from "@/pages/Pages/Settings/TemplateParams.vue";
import TemplateParam from "@/pages/Pages/Settings/TemplateParam.vue";

const settingsMenu: RouteConfig = {
    path: "/settings",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    redirect: "/settings/originators",
    name: "Settings",
    children: [
        {
            path: "service_providers",
            name: "service_providers",
            components: {default: ServiceProviders},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.providers'
            }
        },
        {
            path: "service_providers/new",
            name: "service_providers_new",
            components: {default: ServiceProvider},
            meta: {
                icon: "settings",
                parentPath: "/settings/service_providers",
                msgKey: 'menu.item.settings.providers'
            },
        },
        {
            path: "service_providers/:id",
            name: "service_providers_edit",
            components: {default: ServiceProvider},
            meta: {
                icon: "settings",
                parentPath: "/settings/service_providers",
                msgKey: 'menu.item.settings.providers'
            }
        },
        {
            path: "partners",
            name: "partners",
            components: {default: Partners},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.clients'
            }
        },
        {
            path: "partners/new",
            name: "partners_new",
            components: {default: Partner},
            meta: {
                icon: "settings",
                parentPath: "/settings/partners",
                msgKey: 'menu.item.settings.clients'
            },
        },
        {
            path: "partners/:id",
            name: "partners_edit",
            components: {default: Partner},
            meta: {
                icon: "settings",
                parentPath: "/settings/partners",
                msgKey: 'menu.item.settings.clients'
            }
        },
        {
            path: "accounts",
            name: "accounts",
            components: {default: Accounts},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.accounts'
            }
        },
        {
            path: "accounts/new",
            name: "accounts_new",
            components: {default: Account},
            meta: {
                icon: "settings",
                parentPath: "/settings/accounts",
                msgKey: 'menu.item.settings.accounts'
            },
        },
        {
            path: "accounts/:id",
            name: "accounts_edit",
            components: {default: Account},
            meta: {
                icon: "settings",
                parentPath: "/settings/accounts",
                msgKey: 'menu.item.settings.accounts'
            }
        },
        {
            path: "originators",
            name: "originators",
            components: {default: Originators},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.senders'
            }
        },
        {
            path: "originators/new",
            name: "originators_new",
            components: {default: Originator},
            meta: {
                icon: "settings",
                parentPath: "/settings/originators",
                msgKey: 'menu.item.settings.senders'
            },
        },
        {
            path: "originators/:id",
            name: "originators_edit",
            components: {default: Originator},
            meta: {
                icon: "settings",
                parentPath: "/settings/originators",
                msgKey: 'menu.item.settings.senders'
            }
        },
        {
            path: "system_settings",
            name: "system_settings",
            components: {default: SystemSettings},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.cms'
            }
        },
        {
            path: "system_settings/new",
            name: "system_settings_new",
            components: {default: SystemSetting},
            meta: {
                icon: "settings",
                parentPath: "/settings/system_settings",
                msgKey: 'menu.item.settings.cms'
            }
        },
        {
            path: "system_settings/:id",
            name: "system_settings_edit",
            components: {default: SystemSetting},
            meta: {
                icon: "settings",
                parentPath: "/settings/system_settings",
                msgKey: 'menu.item.settings.cms'
            }
        },
        {
            path: "message_types",
            name: "message_types",
            components: {default: MessageTypes},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.message.types'
            }
        },
        {
            path: "message_types/new",
            name: "message_types_new",
            components: {default: MessageType},
            meta: {
                icon: "settings",
                parentPath: "/settings/message_types",
                msgKey: 'menu.item.settings.message.types'
            }
        },
        {
            path: "message_types/:id",
            name: "message_types_edit",
            components: {default: MessageType},
            meta: {
                icon: "settings",
                parentPath: "/settings/message_types",
                msgKey: 'menu.item.settings.message.types'
            }
        },
        {
            path: "message_categories",
            name: "message_categories",
            components: {default: MessageCategories},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.message.categories'
            }
        },
        {
            path: "message_categories/regexes",
            name: "message_categories_regexes",
            components: {default: Regexes},
            meta: {
                icon: "settings",
                parentPath: "/settings/message_categories",
                msgKey: 'menu.item.settings.message.categories'
            }
        },
        {
            path: "message_categories/new",
            name: "message_categories_new",
            components: {default: MessageCategory},
            meta: {
                icon: "settings",
                parentPath: "/settings/message_categories",
                msgKey: 'menu.item.settings.message.categories'
            }
        },
        {
            path: "message_categories/:id",
            name: "message_categories_edit",
            components: {default: MessageCategory},
            meta: {
                icon: "settings",
                parentPath: "/settings/message_categories",
                msgKey: 'menu.item.settings.message.categories'
            }
        },
        {
            path: "reports",
            name: "reports",
            components: {default: Reports},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.statistics.export.reports'
            }
        },
        {
            path: "duplicates",
            name: "duplicates",
            components: {default: Duplicates},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.duplicate'
            }
        },
        {
            path: "duplicates/new",
            name: "duplicates_new",
            components: {default: Duplicate},
            meta: {
                icon: "settings",
                parentPath: "/settings/duplicates",
                msgKey: 'menu.item.settings.duplicate'
            }
        },
        {
            path: "duplicates/:id",
            name: "duplicates_edit",
            components: {default: Duplicate},
            meta: {
                icon: "settings",
                parentPath: "/settings/duplicates",
                msgKey: 'menu.item.settings.duplicate'
            }
        },
        {
            path: "quantity_limits",
            name: "quantity_limits",
            components: {default: QuantityLimits},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.quantity.limits'
            }
        },
        {
            path: "quantity_limits/new",
            name: "quantity_limits_new",
            components: {default: QuantityLimit},
            meta: {
                icon: "settings",
                parentPath: "/settings/quantity_limits",
                msgKey: 'menu.item.settings.quantity.limits'
            }
        },
        {
            path: "quantity_limits/:id",
            name: "quantity_limits_edit",
            components: {default: QuantityLimit},
            meta: {
                icon: "settings",
                parentPath: "/settings/quantity_limits",
                msgKey: 'menu.item.settings.quantity.limits'
            }
        },
        {
            path: "provider_connections",
            name: "provider_connections",
            components: {default: ProviderConnections},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.logica.smpp'
            }
        },
        {
            path: "preprocessing_rules",
            name: "preprocessing_rules",
            components: {default: PreprocessingRules},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.preprocessing'
            }
        },
        {
            path: "preprocessing_rules/new",
            name: "preprocessing_rules_new",
            components: {default: PreprocessingRuleItem},
            meta: {
                icon: "settings",
                parentPath: "/settings/preprocessing_rules",
                msgKey: 'menu.item.settings.preprocessing'
            }
        },
        {
            path: "preprocessing_rules/:id",
            name: "preprocessing_rules_edit",
            components: {default: PreprocessingRuleItem},
            meta: {
                icon: "settings",
                parentPath: "/settings/preprocessing_rules",
                msgKey: 'menu.item.settings.preprocessing'
            }
        },
        {
            path: "smpp_connections",
            name: "smpp_connections",
            components: {default: SmppConnections},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.operator.smpp'
            }
        },
        {
            path: "smpp_connections/new",
            name: "smpp_connections_new",
            components: {default: SmppConnection},
            meta: {
                icon: "settings",
                parentPath: "/settings/smpp_connections",
                msgKey: 'menu.item.settings.operator.smpp'
            },
        },
        {
            path: "smpp_connections/:id",
            name: "smpp_connections_edit",
            components: {default: SmppConnection},
            meta: {
                icon: "settings",
                parentPath: "/settings/smpp_connections",
                msgKey: 'menu.item.settings.operator.smpp'
            }
        },
        {
            path: "partners_connections",
            name: "partners_connections",
            components: {default: PartnersConnections},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.server.smpp'
            }
        },
        {
            path: "black_lists",
            name: "black_lists",
            components: {default: BlackLists},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.black.list'
            },
        },
        {
            path: "black_lists/new",
            name: "black_lists_new",
            components: {default: BlackList},
            meta: {
                icon: "settings",
                parentPath: "/settings/black_lists",
                msgKey: 'menu.item.settings.black.list'
            },
        },
        {
            path: "black_lists/:id",
            name: "black_lists_edit",
            components: {default: BlackList},
            meta: {
                icon: "settings",
                parentPath: "/settings/black_lists",
                msgKey: 'menu.item.settings.black.list'
            },
        },
        {
            path: "black_lists/:id/recipients",
            name: "black_list_contacts",
            components: {default: BlackListContacts},
            meta: {
                icon: "settings",
                parentPath: "/settings/black_lists",
                msgKey: 'menu.item.settings.black.list'
            },
        },
        {
            path: "black_lists/:id/recipients/new",
            name: "black_list_contacts_new",
            components: {default: BlackListContact},
            meta: {
                icon: "settings",
                parentPath: "./",
                msgKey: 'menu.item.settings.black.list'
            },
        },
        {
            path: "black_lists/:id/recipients/:contactId",
            name: "black_list_contacts_edit",
            components: {default: BlackListContact},
            meta: {
                icon: "settings",
                parentPath: `./`,
                msgKey: 'menu.item.settings.black.list'
            },
        },

        {
            path: "black_list/generals/recipients",
            name: "black_list_generals",
            components: {default: BlackListGenerals},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.general.black.list'
            },
        },
        {
            path: "black_list/generals/recipients/new",
            name: "black_list_generals_new",
            components: {default: BlackListGeneral},
            meta: {
                icon: "settings",
                parentPath: "/settings/black_list/generals/recipients",
                msgKey: 'menu.item.settings.general.black.list'
            },
        },
        {
            path: "black_list/generals/recipients/:id",
            name: "black_list_generals_edit",
            components: {default: BlackListGeneral},
            meta: {
                icon: "settings",
                parentPath: "/settings/black_list/generals/recipients",
                msgKey: 'menu.item.settings.general.black.list'
            },
        },
        {
            path: "template_params",
            name: "template_params",
            components: {default: TemplateParams},
            meta: {
                icon: "settings",
                msgKey: 'menu.item.settings.templates.params'
            }
        },
        {
            path: "template_params/new",
            name: "template_params_new",
            components: {default: TemplateParam},
            meta: {
                icon: "settings",
                parentPath: "/settings/template_params",
                msgKey: 'menu.item.settings.templates.params'
            },
        },
        {
            path: "template_params/:id",
            name: "template_params_edit",
            components: {default: TemplateParam},
            meta: {
                icon: "settings",
                parentPath: "/settings/template_params",
                msgKey: 'menu.item.settings.templates.params'
            }
        }
    ]
}

export default settingsMenu;
